import { AbstractModel, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RiderFare extends AbstractModel {
  @autoserialize
  reservationId: number;

  @autoserialize
  organizationPaymentMethodName: string;

  @autoserialize
  fareCollected: boolean;

  @autoserialize
  paymentMethodId: number;

  @autoserialize
  ticketNumber: string;

  @autoserialize
  cashAmount: number;

  @autoserialize
  ticketValue: number;

  @autoserialize
  collectedOffline: boolean;

  // Local

  @autoserialize
  clientUUID: string;

  confirmationValue: number;

  /**** Comparison ****/

  equals(riderFare: RiderFare): boolean {
    if (!isNullOrUndefined(this.id) && this.id === riderFare.id) {
      return true;
    }

    if (!isNullOrUndefined(this.clientUUID) && this.clientUUID === riderFare.clientUUID) {
      return true;
    }

    return false;
  }
}
